// extracted by mini-css-extract-plugin
module.exports = {"textbase":"styles_textbase__Eg2Qg"};